var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseNavBar'),_c('VContent',{staticClass:"view-content"},[_c('VContainer',{attrs:{"fluid":"","px-0":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }